<template>
  <v-container fluid>
    <!-- <material-card icon="mdi-account-tie-voice" inline title="Announcements"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="2" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Announcements
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      <v-card-component>
        <v-timeline>
          <v-timeline-item v-for="anmt in announcements" :key="anmt.createdAt" :color="anmt.color">
            <template v-slot:opposite>
              <span :class="`headline font-weight-bold ${anmt.color}--text`" v-text="anmt.userOfType"></span>
            </template>
            <template>
              <span class="caption" v-text="anmt.Date"></span>
            </template>
            <div class="py-4">
              <h2 :class="`headline font-weight-light mb-4 ${anmt.color}--text`" v-text="anmt.title"></h2>
              <div v-html="anmt.description"></div>
            </div>
            <div v-if="anmt.docs.length > 0">
              <div class="body-2 mb-2">Attachments:</div>
              <span class="tags d-inline-block mr-4" v-for="(file, i) in anmt.docs" :key="i">
                <v-btn small elevation="1" class="caption" @click="download(file.urlPath)"> <v-icon left color="primary">mdi-download</v-icon>{{ shortPath(file.urlPath) }} </v-btn>
              </span>
            </div>
            <div class="text-right font-italic" v-text="anmt.from"></div>
          </v-timeline-item>
        </v-timeline>
      </v-card-component>
      </v-card>
    <!-- </material-card> -->
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
// import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: 'announcementView',
  components: {

    VCardComponent
  },
  data () {
    return {
      isLoading: false,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      academicYearID: '',
      inProgress: false,
      franchiseeID: '',
      announcements: [],
      events: [],
      input: null,
      nonce: 0
    }
  },
  async created () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    timeline () {
      return this.events.slice().reverse()
    }
  },
  mounted () {
    this.onFranchiseeChange()
  },
  methods: {
    shortPath: function (urlPath) {
      return urlPath.split('\\').pop().split('/').pop()
    },
    download: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    comment () {
      const time = new Date().toTimeString()
      this.events.push({
        id: this.nonce++,
        text: this.input,
        time: time.replace(/:\d{2}\sGMT-\d{4}\s\((.*)\)/, (match, contents, offset) => {
          return ` ${contents
            .split(' ')
            .map(v => v.charAt(0))
            .join('')}`
        })
      })

      this.input = null
    },

    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
          this.academicYears = this.academicYear.academicYear
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
      this.Save()
    },
    async Save () {
      this.isLoading = true
      if (this.academicYearID && this.franchiseeID !== ' ') {
        this.isLoading = true
        this.fromDate = this.academicYears.toString().split('-')[0]
        this.toDate = this.academicYears.toString().split('-')[1]
        this.announcements = []
        try {
          const { data } = await http.get(`${constants.API_URL}/api/communication/announcements/user-type1`, {
            params: {
              academicYearID: this.academicYearID,
              franchiseeID: this.franchiseeID,
              fromDate: `${this.fromDate}-04-01`,
              toDate: `${this.toDate}-03-31`
            }
          })
          if (data.length === 0) {
            this.$dialog.error({
              text: 'No Data Found',
              title: 'No Data'
            })
          } else {
            let announcements = []
            data.forEach(e => {
              if (e.isActive === true) {
                let userOfType = ''
                let color = ''
                if (e.userType === 'STAFF_STAFF') {
                  userOfType = 'ALL STAFF'
                  color = 'primary'
                }
                if (e.userType === 'STAFF_TEACHING') {
                  userOfType = 'TEACHING STAFF'
                  color = 'info'
                }
                if (e.userType === 'STAFF_NON_TEACHING') {
                  userOfType = 'NON TEACHING STAFF'
                  color = 'success'
                }
                if (e.userType === 'PARENT') {
                  userOfType = 'PARENT'
                  color = 'pink'
                }
                if (e.userType === 'STUDENT_WISE') {
                  userOfType = 'STUDENT'
                  color = 'warning'
                }
                if (e.userType === 'ALL') {
                  userOfType = 'ALL'
                  color = 'darkblue'
                }
                announcements.push({
                  Date: moment(e.createdAt, 'YYYY-MM-DD').format('LL'),
                  title: `${e.title}`,
                  description: e.descriptions,
                  from: `${e.user.firstName} ${e.user.lastName}`,
                  userOfType,
                  color,
                  docs: e.announcementDocumentMaps
                })
              }
            })
            this.announcements = _.take(announcements, '15')
          }

          this.isLoading = false
        } catch (e) {
          this.isLoading = false
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          console.log('Error While Saving Data', errorMessage)
        }
      }
    }
  }
}
</script>
